import { type DependencyList, useEffect } from "react";

export const useAsyncImpact = (effect: () => Promise<void>, deps: DependencyList): void => {
  useEffect(() => {
    void effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);
};
